let PackagesItem = [
    {
        id: 1,
        trackTitle: "PRO TRACK 🔥",
        trackSubtitle: "For Senior Software Architects, CTOs and Founders",
        trackPrice: "$99",
        trackDesc: "1",
        trackButton: "Register",
        trackFull: 'Full Access to Q&A sessions',
        trackLink: 'https://geekle.us/ticket/1639989205257x711167148378816500',
    },
    // {
    //     id: 3,
    //     trackTitle: "Support Ukraine",
    //     trackSubtitle: "For attendees who want to help our country",
    //     trackPrice: "$499",
    //     trackDesc: "3",
    //     trackButton: "Support",
    //     trackLink: 'https://geekle.us/ticket/1646214592681x396311874145353700',
    // },
    {
        id: 2,
        trackTitle: "CAREER TRACK",
        trackSubtitle: "For Software Developers, Junior&Middle Software Architects",
        trackPrice: "FREE",
        trackButton: "Register",
        trackQA: 'Live Q&A panels from a Career track',
        trackLink: 'https://geekle.us/ticketfree/1639988922813x151032241736384500',
    },
  ];
  
  export default PackagesItem;
  